<template>
	<a
		class="site_button"
		:href="button_link.url ? button_link.url : link"
		:target="button_link.target ? button_link.target : target"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		:style="{
      '--site-button-colour': colour,
      '--site-button-text-colour': button_text_colour,
      '--min-height': minHeight + 'px',
      '--border-thickness': borderThickness + 'px',
			'--margin-top': margin_top + 'px',
			'--margin-bottom': margin_bottom + 'px',
			'--margin-right': margin_right + 'px',
			'--margin-left': margin_left + 'px',
			'--display-type': display_type
    }"
		:class="{ 'no-border': border === 'no', primary: type === 'primary' }"
		ref="site_button"
	>
		<span v-html="button_label ? button_label : label"></span>
	</a>
</template>

<script>
export default {
  data() {
    return {
      button_label: this.label,
      button_link: this.link,
      hovered: false,
      // button_colour: this.colour.replace('"', ''),
      // button_textcolour: this.button_text_colour.replace('"', ''),
    };
  },

  props: {
    link: {
      default: '#',
    },
    label: {
      default: 'Site Button',
    },
    target: {
      default: '_self',
    },
    colour: {
      default: '#00ffa3',
    },
    button_text_colour: {
      default: '#024fa8',
    },
    border: {
      default: 'yes',
    },
    minHeight: {
      default: '40',
    },
    borderThickness: {
      default: '1',
    },
    isProduct: {
      default: 'no',
    },
    type: {
      default: 'standard',
    },
    margin_top: {
      default: '0',
    },
    margin_bottom: {
      default: '0',
    },
		margin_left: {
      default: '0',
    },
    margin_right: {
      default: '0',
    },
		display_type: {
      default: 'inline-grid',
    },
  },

  computed: {},

  watch: {
    link() {
      this.button_link = this.link;
    },
  },

  methods: {
    checkEmpty(e) {
      if (this.button_link && this.button_link.url === '#') {
        // this.$refs.site_button.removeAttribute('href');
        e.preventDefault();
      }
    },
  },

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/common/variables';

.site_button {
  border: 1px solid var(--site-button-colour);
  background: var(--site-button-colour);
  padding: 0 $spacer * 2;
  display: var(--display-type);
  grid-template-columns: 1fr;
  justify-content: flex-start;
  align-items: center;
  min-height: var(--min-height);
  max-width: calc(100% - 82px);
  width: auto;
  text-decoration: none;
  column-gap: $spacer;
  transition: 0.2s ease all;
	margin-top: var(--margin-top);
	margin-bottom: var(--margin-bottom);
	margin-right: var(--margin-right);
	margin-left: var(--margin-left);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 5px 5px rgba(#000, 0.5);
    transition: 0.2s ease all;
  }

  @media (max-width: $lg) {
    width: 100%;
  }

  &.no-border {
    border: 0px solid transparent;
    padding: 0 $spacer;
    max-width: calc(100% - 40px);
    column-gap: 0;

    span {
      padding-bottom: $spacer / 2;
      border-bottom: var(--border-thickness) solid var(--site-button-colour);
    }
  }

  &.primary {
    border: 1px solid $cpmec-green;
    background: $cpmec-green;
    transition: 0.2s ease all;

    span {
      color: $cpmec-blue;
    }

    .arrow {
      svg {
        position: absolute;
        right: 0;
        path {
          fill: $cpmec-blue;
        }
      }
    }
  }

  &:hover {
    cursor: pointer;
  }

  span {
    color: var(--site-button-text-colour);
    font-size: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteButton.vue